import React from 'react';
import { useGetObservationTypesQuery } from 'Services/api/observationTypesApi';
import { ObservationType } from 'Features/Settings/Settings.Common/Common.ObservingPrograms/CreateProgram/types';
import { SelectObjectById } from './SelectObjectById';
import { CommonSelectProps } from './types';

function SelectObservationTypeDefault({
  selected,
  onChangeValue,
  firstOptionLabel = '',
  ...selectProps
}: CommonSelectProps) {
  const { data: types, isLoading, isFetching } = useGetObservationTypesQuery(undefined);
  const optionLabel = (type: ObservationType) => type.description;

  return (
    <SelectObjectById
      {...selectProps}
      name="observationType"
      data={types}
      selected={selected}
      onChangeValue={onChangeValue}
      isLoading={isLoading || isFetching}
      firstOptionLabel={firstOptionLabel || 'ВСЕ'}
      optionLabel={optionLabel}
    />
  );
}

export const SelectObservationType = React.memo(SelectObservationTypeDefault);
SelectObservationType.displayName = 'SelectObservationType';
